var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heroesLeaderboard"},[_c('el-scrollbar',{staticClass:"course-ware-list"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }